<template>
    <div class="content-box">
        <div class="content">
            <div class="title-box">
                <div class="title">
                    <div class="title-text">合作模式</div>
                    <div class="title-e">COOPERATION MODEL</div>
                    <div class="title-line"></div>
                </div>
                <div class="end-rukou">
                </div>
            </div>
            <div class="describe">
                新能源城市配送共享服务平台可为运力企业提供定制化合作模式，运力企业可根据自身实际情况选择适合自己的一种或多种组合的合作模式。
            </div>
            <div class="describe-characteristic2 mt">
                <div class="describe-characteristic-item">
                    <div class="item-img img41"></div>
                    <div class="item-text">货运物流服务</div>
                </div>
                <div class="describe-characteristic-item">
                    <div class="item-img img42"></div>
                    <div class="item-text">税筹物流服务</div>
                </div>
                <div class="describe-characteristic-item">
                    <div class="item-img img43"></div>
                    <div class="item-text">平台SaaS服务</div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
	export default {
		data() {
			return {}
		},
		methods: {},
	}
</script>
<style src="./../../../styles/public-item.less" lang="less" scoped></style>